import React, { useRef } from 'react';

import result_1 from '../../assets/img/results/5269362588414767846.jpg';
import result_2 from '../../assets/img/results/5271573624693847484.jpg';
import result_3 from '../../assets/img/results/5271573624693847485.jpg';
import result_4 from '../../assets/img/results/5271573624693847491.jpg';
import result_5 from '../../assets/img/results/5271573624693847493.jpg';
import result_6 from '../../assets/img/results/5271573624693847496.jpg';
import result_7 from '../../assets/img/results/5271573624693847497.jpg';
import result_8 from '../../assets/img/results/5271573624693847498.jpg';
import result_9 from '../../assets/img/results/5271573624693847502.jpg';
import result_10 from '../../assets/img/results/5271573624693847503.jpg';
import result_11 from '../../assets/img/results/5271573624693847511.jpg';
import result_12 from '../../assets/img/results/5271573624693847512.jpg';

// --------------- SWIPER --------------------
// import Swiper core and required modules
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// --------------- /SWIPER --------------------

import styles from './ResultsBlock.module.css';

export default function ResultsBlock() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <section id="4" className={styles.container}>
      <div className={styles.title}>Результати</div>
      <div className={styles.slider_wrapper}>
        {/* Кастомні кнопки */}
        <div ref={prevRef} className={styles.swiper_button_prev}>
          ←
        </div>
        <div ref={nextRef} className={styles.swiper_button_next}>
          →
        </div>
        <Swiper
          className={styles.swiper_wrappe}
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          loop={true}
          // navigation={true}
          pagination={{ clickable: true }}
          onBeforeInit={(swiper) => {
            // Прив'язка кастомних кнопок ДО ініціалізації
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          // onSwiper={(swiper) => console.log(swiper)}
          // onSlideChange={() => console.log('slide change')}

          breakpoints={{
            // коли ширина >= 640px
            640: {
              slidesPerView: 2,
            },
            // коли ширина >= 1024px
            1024: {
              slidesPerView: 3,
            },
          }}>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_1} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_2} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_3} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_4} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_5} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_6} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_7} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_8} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_9} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_10} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_11} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.img_wrapper}>
              <img src={result_12} />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
}
